<template>
  <v-card>
    <v-card-title class="headline py-2">
      Статусы сотрудника
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-layout>
        <v-flex xs12 md6>
          <v-checkbox label="Полный доступ" v-model="fullAccess" hide-details></v-checkbox>
          <v-treeview :items="statusesTree" v-model="tree" item-key="key" selectable return-object>
            <template slot="prepend" slot-scope="{item}">
              <v-icon size="20" class="mx-0" :color="item.color">{{item.icon}}</v-icon>
            </template>
            <label slot="label" class="pointer" slot-scope="{item}" @click>{{item.name}}</label>
          </v-treeview>
        </v-flex>
        <v-flex xs12 md6>
          <v-chip v-for="item in selectedStatuses" :color="item.color" :dark="darkBg(item.color)" :key="item.id">
            <v-icon size="20" left class="mr-1">{{item.icon}}</v-icon>
            {{item.name}}
          </v-chip>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { is_dark } from '@/helpers/app'

export default {
  name: 'StatusAttach',

  computed: {
    ...mapState(`orgstructure/anketa`, ['statusesTree'])
  },

  props: {
    id: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  created() {
    this.$store.dispatch('orgstructure/anketa/getStatuses').then(_ => {
      this.data.map(item => {
        this.tree.push({ key: 's_' + item.id })
        if (item.id === 0) {
          this.fullAccess = true
        }
      })
    })
  },

  data() {
    return {
      status: {
        btnDisabled: false,
        text: '',
        className: 'success--text darken-1'
      },
      tree: [],
      selectedStatuses: [],
      fullAccess: false
    }
  },

  methods: {
    toggleSelected(item) {
      let index = this.selectedStatuses.findIndex(el => el.key === item.key)
      if (index < 0) {
        this.selectedStatuses.push(item)
      } else {
        this.selectedStatuses.splice(index, 1)
      }
    },

    darkBg(color) {
      return color ? is_dark(color) : false
    },

    submit() {
      this.status = { btnDisabled: true, text: 'Сохранение', className: 'secondary--text lighten-1' }
      let statuses = [...this.selectedStatuses]
      if (this.fullAccess) {
        statuses.push({ id: 0, color: '#A5A5A5', element_type: 'status', icon: null, key: 's_0', name: 'Полный доступ', parent_id: null })
      }
      let data = {
        statuses_ids: statuses.map(el => {
          return el.id
        }),
        id_type: 'form',
        id: this.id
      }

      this.$store
        .dispatch('orgstructure/anketa/attachStatuses', data)
        .then(response => {
          this.status = { btnDisabled: false, text: 'Сохранено', className: 'success--text darken-1' }
          this.$emit('save', { type: 'statuses', data: statuses })
        })
        .catch(error => {
          this.status = { btnDisabled: false, text: 'Ошибка', className: 'error--text darken-1' }
        })
    }
  },

  watch: {
    tree(val) {
      this.selectedStatuses = val.filter(item => item.element_type === 'status')
    }
  }
}
</script>

<style scoped>
.status-tree-checkbox {
  width: 25px;
  flex: initial;
}
</style>


// WEBPACK FOOTER //
// src/apps/org/components/Anketa/Forms/StatusAttach.vue